<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<div class="card-header bg-theme">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<app-question-form *ngIf="showForm" [uId]="uId" (created)="onSave($event)"
			(cleared)="onCleared()"></app-question-form>
	</div>
</div>